import AWS from 'aws-sdk';
import { configure } from 'mobx';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getS3AccessCreds,
  selectS3Success
} from '../../features/aws/awsSlice';
import App from './components/App';
import './index.css';
import S3DirectoryListBuilder from './services/S3DirectoryListBuilder';
import SortClassDeterminator from './services/SortClassDeterminator';
import * as s3ConfigDeterminator from './services/s3ConfigDeterminator';
import searchFilter from './services/searchFilter';
import sortItems from './services/sortItems';
import AppStore from './stores/AppStore';
import SortStore from './stores/SortStore';
import { Space } from 'antd';

configure({
  enforceActions: 'always',
  computedRequiresReaction: true,
  reactionRequiresObservable: true,
  observableRequiresReaction: true,
});

const S3Browser = () =>  {
const sortStore = new SortStore('name', 'asc');
const appStore = new AppStore();
const sortClassDeterminator = SortClassDeterminator(
  ['name', 'lastModified', 'size'],
  'sort-none',
  'sort-asc',
  'sort-desc'
);
const dispatch = useDispatch();
const s3Creds = useSelector(selectS3Success);

useEffect(() => {
  dispatch(getS3AccessCreds())
},[])

useEffect(() => {
    if(s3Creds.access_key_id && s3Creds.access_key_id.length > 0) {
      loadData();
    }
},[s3Creds])

async function loadData() {
  try {
        
        let contents = "";
        const bucketName = s3Creds.bucket;
        const objectUrlBase = `https://${s3Creds.bucket}.s3.amazonaws.com`;
        const basePath = '/s3-browser';
        const accessKeyId= s3Creds.access_key_id;
        const secretAccessKey=s3Creds.secret_access_key;
        const s3Client = new AWS.S3({
          accessKeyId,
          secretAccessKey
        });
        
        const data = await  s3Client.listObjectsV2({
            Bucket: s3Creds.bucket,
            Prefix: s3Creds.s3_filepath+'/',
          }).promise();
        
        contents = await new Promise((resolve, reject) => setTimeout(() => resolve(data.Contents), 500));
        const treeBuilder = S3DirectoryListBuilder(bucketName, objectUrlBase);
        const { root, directories } = treeBuilder(contents);

    appStore.onLoaded({ root, directories, basePath });
  } catch (error) {
    console.error(error);
    if (error instanceof s3ConfigDeterminator.CannotDetermineBucket) {
      appStore.onError(error.message);
    } else {
      appStore.onError('Error loading data');
    }
  }
}



return(
  s3Creds.s3_filepath && s3Creds.access_key_id && s3Creds.access_key_id.length > 0 ? <App
    sortStore={sortStore}
    appStore={appStore}
    sortClassDeterminator={sortClassDeterminator}
    searchFilter={searchFilter}
    sortItems={sortItems}
    accessKeyId={s3Creds.access_key_id}
    secretAccessKey={s3Creds.secret_access_key}
    bucket={s3Creds.bucket}
  />:  <Space style={{margin:'40px'}}> <b><div className="c-header__col-main">
  <div className="c-header__subtitle">
      This user does not have access to s3 files currently.
  </div>
</div></b></Space>

);

}

export default S3Browser;